// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--fo3iO","chat-container":"_7a3fb80146--chat-container--hV4km","jump":"_7a3fb80146--jump--joYmu"};